module.exports = "/wp-content/themes/lanthiaresort/modules/public/images/bd6996f9c0921f5e744aba81d3dadd84.png";